import React from "react";
import Select from "react-select";
import { ValueType } from "react-select/src/types";

export type SelectOption = { value: any; label: string };

type DropdownProps = {
  id: string;
  options: { value: any; label: string }[];
  value: ValueType<SelectOption, any>;
  onChange(selectedOption: ValueType<SelectOption, any>): void;
  roundedRectangle?: boolean;
  small?: boolean;
  defaultMenuIsOpen?: boolean;
  customClassName?: string;
  customNoOptionsMessage?: string;
  placeholder?: string;
  isClearable?: boolean;
  readOnly?: boolean;
  isMulti?: boolean;
};

type Props = DropdownProps;

const Dropdown: React.FC<Props> = ({
  id,
  options,
  value,
  onChange,
  roundedRectangle,
  small,
  defaultMenuIsOpen,
  customClassName,
  customNoOptionsMessage,
  placeholder,
  isClearable = false,
  readOnly,
  isMulti,
}) => {
  return (
    <Select
      inputId={id}
      className={`${
        roundedRectangle
          ? small
            ? "CustomSelect RoundedRect Small"
            : "CustomSelect RoundedRect"
          : small
          ? "CustomSelect Small"
          : "CustomSelect"
      } ${customClassName ? customClassName : ""}`}
      defaultMenuIsOpen={defaultMenuIsOpen}
      classNamePrefix="CustomSelect"
      options={options}
      value={value}
      onChange={onChange}
      menuPlacement="auto"
      noOptionsMessage={
        customNoOptionsMessage ? () => customNoOptionsMessage : undefined
      }  
      placeholder={placeholder || null}   
      isClearable={isClearable} 
      isDisabled={readOnly}
      isMulti={isMulti}
    />
  );
};

export { Dropdown };
